import { CallState, LoadingState } from '@lcs/shared/api';
import { Action, createReducer, on } from '@ngrx/store';
import { onReset } from 'src/app/authentication/reset-reducer';
import * as AddExtensionGroupActions from './add-extension-group.actions';

export const addExtensionGroupFeatureKey = 'addExtensionGroup';

export interface AddExtensionGroupState {
   callState: CallState;
}

export const initialState: AddExtensionGroupState = {
   callState: LoadingState.Init,
};

const addExtensionGroupReducer = createReducer(
   initialState,
   onReset(initialState),
   on(AddExtensionGroupActions.createExtensionGroup, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(AddExtensionGroupActions.createExtensionGroupSuccess, (state) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   }),
   on(AddExtensionGroupActions.createExtensionGroupFailure, (state) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   })
);

export function reducer(state: AddExtensionGroupState | undefined, action: Action) {
   return addExtensionGroupReducer(state, action);
}
